<template>
    <div id="lista_partc">
        <fieldset class="mt-2">
            <h5 class="card-dados">
                Participantes
            </h5>
            <div>
                <DataTable :url_ajax="getUrlGrid()" :ajax_set_result="setResult" @grid_refreshed="gridRefreshed"
                           :refresh="refresh_grid" :filtros="filtro" method="GET" :qtd_registros_por_pagina="20" :is_table="true"
                           :footer_fixed="false" :headers="header_selected" :pBtnsSlot="true" :is_NotLoading="NotLoading"
                           borderBottom="border-bottom: 1px solid grey" dataPadd="ps-2"
                           customHeight="margin-top: 0px !important;max-height: calc(100vh - 37rem);min-height: calc(100vh - 37rem);"
                           customHeightPaginate="margin-top: 0px !important;max-height: calc(100vh - 40rem);min-height: calc(100vh - 40rem);"
                           sizeWidBootonNopaginate="margin-left:-2px" @retorna_total_registros="retorna_total_registros"
                           class="mt-2" :column_slot="true">
                    <template v-slot:cell-slot_cdLocalizador="item">
                        <div class="d-flex justify-content-center">
                            <div class="d-flex flex-column mt-1 mb-2">
                                <div class="text-center fw-bold"><a :href="'https://gnp.negociospublicos.net.br/NP/Eventos/Inscricao/InscricaoParticipantes/?p_cdLocalizador=' + item.row.cdLocalizador" target="blank">{{ item.row.cdLocalizador }}</a></div>
                                <div class="text-center text-danger fw-bold" v-if="item.row.dsLoginInclusao == 'NP.Eventos' || item.row.dsLoginInclusao == 'NP.imp'">Interno</div>
                                <div class="text-success fw-bold" v-else>Externo</div>
                                <div class="text-center fw-bold"><a :href="'https://gnp.negociospublicos.net.br/NP/Eventos/Inscricao/inscricaoPagamentoCartao/?p_cdLocalizador=' + item.row.cdLocalizador" target="blank">Pagar</a></div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell-slot_nmUf="item">
                        <div style="min-width: 100px; height: 100%; text-align:left;">
                            Data: {{ item.row.dtInclusao }} | UF: <strong>{{ item.row.nmUf }}</strong><br>
                            <div style="width: 100%; height: 100%;text-align:left;">
                                {{ item.row.nmNome }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell-slot_flVinculado="item">
                        <div v-if="(item.row.idPessoa != null && item.row.idInstituicao > 0 && item.row.idInstituicao != null && item.row.idInstituicao > 0)" class="spinner-grow-static text-success" role="status" />
                        <div v-else class="spinner-grow-static text-danger" role="status" />
                    </template>
                    <template v-slot:cell-slot_cdPassaporte="item">
                        <div class="d-flex justify-content-center">
                            <div class="d-flex flex-column mt-1 mb-2">
                                <div class="text-center fw-bold">{{ item.row.cdPassaporte }}</div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell-slot_nmParticipante="item">
                        <div class="d-flex ">
                            <div class="d-flex flex-column mt-1 mb-2">
                                <span>{{ item.row.nmParticipante }}</span>
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell-slot_dsEmail="item">
                        <div class="d-flex ">
                            <div class="d-flex flex-column mt-1 mb-2">
                                <div>
                                    <span class="fw-bold">{{ item.row.nmUf }}</span>
                                    <span> / {{ item.row.dsEmail }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:cell-slot_flVinculado_Participante="item">
                        <div v-if="item.row.tpInstituicao == 'J'">
                            <div v-if="(item.row.idPessoa > 0 && item.row.idInstituicao > 0)" class="spinner-grow-static text-success" role="status" />
                            <div v-else class="spinner-grow-static text-danger" role="status" />
                        </div>
                        <div v-else-if="item.row.tpInstituicao == 'F'">
                            <div v-if="(item.row.idPessoa > 0)" class="spinner-grow-static text-success" role="status" />
                            <div v-else class="spinner-grow-static text-danger" role="status" />
                        </div>
                    </template>
                    <template v-slot:cell-slot_flCancelado_Participante="item">
                        <div>
                            <button class="btn btn-light text-success btn-ativo" v-on:click="openModalCancelarParticipante(item.row.idParticipante)" v-if="item.row.flCancelado != 'Sim'">
                                <i class="fas fa-check"></i>
                            </button>
                            <button class="btn btn-light text-danger btn-ativo" v-on:click="openModalCancelarParticipante(item.row.idParticipante)" v-else>
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </template>
                    <!--<template v-slot:cell-slot_dsLoginConsultor="item">
                        <div class="d-flex ">
                            <div class="d-flex flex-column mt-1 mb-2">
                                <span :class="(dsLoginConsultor == 'SEM CONSULTOR'?'text-danger':'')">{{ item.row.dsLoginConsultor }}</span>
                            </div>
                        </div>
                    </template>-->
                    <template v-slot:BtnSlot="item">

                        <div class="row">
                            <button class="btn-grid-editar-lista" style="width: max-content;margin: 0;height: 35px;" type="button" title="Alterar Passaporte" @click="carregaParticipante(item.row.idInscricao, item.row.idParticipante)">
                                <i class="fas fa-pencil-alt"></i>
                            </button>
                            <!--<button class="btn-grid-editar-lista ms-1" style="width: max-content;margin: 0;height: 35px;" type="button" title="Ver Acompanhamento de Contato" :disabled="item.row.idAcompanhamentoContato == null" @click="abreAcompanhamento(item.row.idAcompanhamentoContato)">
                            <i class="fas fa-eye"></i>
                        </button>-->
                            <template v-if="item.row.flCancelado != 'Sim'">
                                <button class="btn-grid-editar-lista ms-1" style="width: max-content;margin: 0;height: 35px;" type="button" title="Enviar Alerta" :disabled="!(item.row.idInstituicao > 0)" @click="enviarAlertaParticipante(item.row.idInscricao,item.row.idParticipante)">
                                    <i class="fas fa-envelope"></i>
                                </button>
                                <a class="btn-grid-editar-lista ms-1" :href="'https://gnp.negociospublicos.net.br/NP/Eventos/Oficina/?p_cdPassaporte=' + item.row.cdPassaporte" :disabled="!(item.row.idInstituicao > 0)" target="blank" style="width: max-content;margin: 0;height: 35px;"> <i class="fas fa-graduation-cap"></i></a>
                            </template>
                        </div>

                    </template>
                </DataTable>
            </div>
        </fieldset>

        <modal-warper target="dados_passaporte" :show="isOpenModalParticipante" @close="isOpenModalParticipante = false">
            <DadosPassaporte :idInscricao="idInscricao_selected" :idParticipante="idParticipante_selected" :show="isOpenModalParticipante" ref="responsavel_inscricao" @reloadAll="reloadAll" />
        </modal-warper>

        <modal-warper target="disparo_alerta_3" :show="isOpenModalDisparoAlerta" @close="isOpenModalDisparoAlerta = false">
            <DisparoAlerta :id="'disparo_alerta_3'" :idEvento="idEvento" :idParticipante="grid_participante_selected" :show="isOpenModalDisparoAlerta" ref="disparo_alerta" />
        </modal-warper>

        <modal-warper target="status_participante_4" :show="isOpenModalStatusParticipante" @close="isOpenModalStatusParticipante = false">
            <Status_Participante :id="'status_participante_4'" :idParticipante="grid_participante_selected" :show="isOpenModalStatusParticipante" @reloadAll="reloadAll" />
        </modal-warper>

    </div>
</template>

<script>

    import DadosPassaporte from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/DadosPassaporte.vue'
    import DisparoAlerta from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/DisparoAlerta.vue'
    import Status_Participante from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/Status_Participante.vue'

    import ModalWarper from "@/components/App/ModalWarper.vue";
    import DataTable from "@/components/App/Datatable.vue";
    import moment from "moment";
    import $ from "jquery";

    export default {
        name: "ListaParticipantes",
        components: {
            DataTable, ModalWarper, DadosPassaporte, DisparoAlerta, Status_Participante
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            idEvento: {
                type: Number,
                default: 0
            },
            idInscricao: {
                type: Number,
                default: 0
            },
            filtro_text: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                refresh_grid: false,
                filtro: [{ active: true }],
                header_selected: [],
                total_registros: 0,

                idInscricao_selected: null,
                idParticipante_selected: null,

                isOpenModalParticipante: false,
                isOpenModalDisparoAlerta: false,
                grid_inscricao_selected: 0,
                grid_participante_selected: 0,
                isOpenModalStatusParticipante: false,
            };
        },
        methods: {
            reloadAll() {
                this.grid_inscricao_selected = 0;
                this.grid_participante_selected = 0;

                this.isOpenModalParticipante = false;
                this.isOpenModalDisparoAlerta = false;
                this.isOpenModalStatusParticipante = false;

                this.reloadGrid();
            },

            getFiltros() {
                let $this = this;

                this.filtered = "";

                this.showFilters = false;

                this.noShadow = false;

                this.haveShadow = 'shadow-v2';

                this.reloadGrid();
            },

            clearFiltros() {
                this.filtros_Crud = {
                    cdLocalizador: "",
                    nmNome: "",                    
                };
                $("input[type=text]").val("");

                setTimeout(() => {
                    $("input[type=text]").val("");
                }, 200);

                this.filtered = "";
            },

            performSearch() {
            },

            getFormattedDate(date) {
                return moment(date).format("DD/MM/YYYY");
            },

            getUrlGrid() {
                let $this = this;

                $this.header_selected = [
                    {
                        class: "col text-center max_w_90",
                        name: "cdPassaporte",
                        text: "Passaporte",
                        order: 0,
                        slot: true
                    },
                    {
                        class: "col text-center",
                        name: "nmParticipante",
                        text: "Nome",
                        order: 0,
                        slot: true
                    },
                    {
                        class: "col text-center",
                        name: "dsEmail",
                        text: "UF / E-mail",
                        order: 0,
                        slot: true
                    },
                    {
                        class: "col text-center max_w_90",
                        name: "flVinculado_Participante",
                        text: "Vinculado",
                        order: 0,
                        slot: true
                    },
                    {
                        class: "col text-center max_w_90",
                        name: "flCancelado_Participante",
                        text: "Ativo",
                        order: 0,
                        slot: true
                    },                    
                    //{
                    //    class: "col text-center",
                    //    name: "dsLoginConsultor",
                    //    text: "Consultor",
                    //    order: 0,
                    //    slot: false
                    //},
                    {
                        class: "col text-center max_w_130",
                        name: "btns",
                        text: "",
                        actions: true,
                    },
                ];

                return (
                    process.env.VUE_APP_ROOT_EVENTOS_API +
                    "/Inscricao/GetGerenciamentoParticipantes?" +
                    'idEvento=' + $this.idEvento + '&idInscricao=' + $this.idInscricao + '&nmNome=' + $this.filtro_text+
                    $this.filtered
                );
            },

            setResult(result) {
                return result;
            },

            gridRefreshed(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
                $this.NotLoading = false;
            },
            reloadGrid() {
                let $this = this;
                $this.refresh_grid = true;
            },
            retorna_total_registros(index, total) {
                let $this = this;

                $this.total_registros = total;

            },

            // acoes grid
            openModalCancelarParticipante(idParticipante) {
                this.grid_participante_selected = idParticipante;
                this.isOpenModalStatusParticipante = true;
            },

            carregaParticipante(idInscricao, idParticipante) {
                this.idInscricao_selected = idInscricao;
                this.idParticipante_selected = idParticipante;
                this.isOpenModalParticipante = true;
            },

            abreAcompanhamento(idAcompanhamentoContato) {
                alert('Abre aba Acompanhamento Eventos' + idAcompanhamentoContato);
            },

            enviarAlertaParticipante(idInscricao, idParticipante) {
                this.grid_inscricao_selected = idInscricao;
                this.grid_participante_selected = idParticipante;
                this.isOpenModalDisparoAlerta = true;
            },

        },
        mounted() {
            this.getFiltros();
        },
        watch: {
            show(n, o) {
                this.getFiltros();
            },

        },
    };

</script>


<style scoped lang="scss">
    .btn-order {
        box-sizing: border-box;
        width: 50px;
        height: 40px;
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
    }

    .btn-filter {
        box-sizing: border-box;
        width: 50px;
        height: 40px;
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
    }

    .btn-filter-red {
        box-sizing: border-box;
        width: 50px;
        height: 40px;
        left: 1830px;
        top: 21px;
        background: #9f3029;
        border: 1px solid #9f2d39;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        color: #ffffff;
    }

    .spinner-grow-static {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        background-color: currentColor;
        border-radius: 50%;
        opacity: .75;
    }

    a {
        text-decoration: none;
    }

    .btn-ativo {
        width: 40px;
        background-color: transparent;
        border-color: var(--bs-btn-hover-border-color);
    }

    .btn-ativo:hover {
        --bs-btn-border-color: #6c757d;
    }

    .btn-grid-editar-lista[disabled] {
        cursor: not-allowed;
        filter: alpha(opacity = 65);
        -webkit-box-shadow: none;
        box-shadow: none;
        opacity: .65;
    }
</style>